import React, { useEffect, useState, useMemo } from "react"
import { SwipeableDrawer, Box, Typography, Divider, CircularProgress } from "@mui/material"
import axios from "axios"
import { useAuth } from "../../../../context/AuthContext"
import { useAppData } from "../../../../context/AppDataContext"
import TanStackTable from "../../../../components/Tables/TanstackTable" // your existing TanStackTable
import dayjs from "dayjs"

const BreakdownSheet = ({ sheetInfo, onClose }) => {
  const { authToken } = useAuth()
  const { baseApi } = useAppData()
  const [loading, setLoading] = useState(true)
  const [records, setRecords] = useState([])
  const [total, setTotal] = useState(0)

  useEffect(() => {
    if (sheetInfo.open && sheetInfo.clientId && sheetInfo.employeeId && sheetInfo.month != null && sheetInfo.year != null && sheetInfo.selectedDate != null && sheetInfo.ruleName) {
      fetchData()
    }
  }, [sheetInfo])

  const fetchData = async () => {
    setLoading(true)
    try {
      const url = `${baseApi}/employee/incentives/breakdown/${sheetInfo.clientId}/${sheetInfo.employeeId}/${sheetInfo.month}/${sheetInfo.year}/${sheetInfo.selectedDate}/${sheetInfo.ruleName || "all"}`
      const { data } = await axios.get(url, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      setRecords(data.records || [])
      setTotal(data.totalIncentive || 0)
    } catch (e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  const columns = useMemo(() => {
    const baseColumns = [
      { accessorKey: "trans_id", header: "Transaction ID" },
      {
        accessorKey: "transaction_date",
        header: "Transaction Date",
        cell: ({ getValue }) => (getValue() ? dayjs(getValue()).format("YYYY-MM-DD") : ""),
      },
      //   { accessorKey: "action_type", header: "Action Type" },
      { accessorKey: "customer", header: "Customer" },
      { accessorKey: "product_desc", header: "Product" },
      { accessorKey: "mobile", header: "Mobile" },
      { accessorKey: "rule_value", header: "Rule Value" },
      { accessorKey: "payout_tier", header: "Payout Tier" },
      { accessorKey: "payout_value", header: "Payout Value" },
      { accessorKey: "incentive", header: "Incentive" },
      {
        accessorKey: "incentive_date",
        header: "Incentive Date",
        cell: ({ getValue }) => (getValue() ? dayjs(getValue()).format("YYYY-MM-DD") : ""),
      },
      { accessorKey: "trans_type", header: "Trans Type" },
      { accessorKey: "quantity", header: "Quantity" },
    ]

    // Include rule_name column only if fetching multiple rules
    if (sheetInfo.ruleName === "all") {
      baseColumns.splice(6, 0, { accessorKey: "rule_name", header: "Rule Name" }) // insert after mobile
    }

    return baseColumns
  }, [sheetInfo.ruleName])

  const tableTitle = sheetInfo.ruleName && sheetInfo.ruleName !== "all" ? `Rule Breakdown: ${sheetInfo.ruleName}` : "Breakdown Transactions"

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={sheetInfo.open}
      onClose={onClose}
      sx={{ zIndex: 1302 }}
      PaperProps={{
        sx: { borderTopLeftRadius: 20, borderTopRightRadius: 20, p: 2, maxHeight: "80vh" },
      }}
    >
      <Box sx={{ textAlign: "center", mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          {tableTitle}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.7 }}>
          Total Incentive: ${total.toFixed(2)}
        </Typography>
        <Divider sx={{ my: 1 }} />
      </Box>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : records.length === 0 ? (
        <Typography sx={{ textAlign: "center", opacity: 0.6 }}>No breakdown found.</Typography>
      ) : (
        <TanStackTable
          maxHeight={"calc(80vh - 100px)"}
          isAccordion={false}
          isExpanded={true}
          columns={columns}
          tableKey={["id"]} // unique key
          title={"Breakdown Transactions"}
          rows={records}
          pageSize={250}
          total_records={records.length}
        />
      )}
    </SwipeableDrawer>
  )
}

export default BreakdownSheet
